(() => {
  if (!document.querySelector('#MainContent[data-template="product"]')) return;
  document.body.dataset.template = 'product';

  const emit = (name, detail = {}) => {
    document.dispatchEvent(new CustomEvent(`nn:${name}`, { detail }));
    window.Shopify?.analytics?.publish?.(`nn_${name}`, detail);
  };

  document.addEventListener('pointerup', (event) => {
    if (event.target.closest('nn-product-spin-viewer')) emit('product_spin_interaction');
  }, { passive: true });

  document.addEventListener('play', (event) => {
    if (event.target.matches('.product-information video')) {
      emit('product_video_play', { product: location.pathname });
    }
  }, true);

  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-picker')) emit('variant_selection');
    if (event.target.matches('[data-nn-charm-option] input')) {
      emit('charm_selection', { selected: event.target.checked });
    }
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-nn-charm-picker] summary')) emit('charm_selector_open');
    if (event.target.closest('.add-to-cart-button')) emit('add_to_cart_attempt');
    if (event.target.closest('[data-nn-submit]')) emit('configuration_add_attempt');
  });

  const videos = [...document.querySelectorAll('.product-information video')];
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (!isIntersecting && !target.paused) target.pause();
      });
    }, { threshold: .15 });
    videos.forEach((video) => observer.observe(video));
  }

  const COMPASS_HANDLES = ['oceanic-navigator', 'midnight-gold', 'emerald-voyager', 'burgundy-reserve'];

  const enhanceMobileProduct = () => {
    const handle = location.pathname.match(/^\/products\/([^/?#]+)/)?.[1];
    if (!COMPASS_HANDLES.includes(handle)) return;

    const mediaColumn = document.querySelector('.product-information__media');
    const gallery = mediaColumn?.querySelector('media-gallery');
    const heading = document.querySelector('h1.nn-backpack-product-title, .product-details h1');
    const price = [...document.querySelectorAll('.product-details product-price, .product-details .price')]
      .find((element) => element.textContent.trim());
    const builderDataNode = document.querySelector('[data-nn-builder-data]');
    if (!mediaColumn || !gallery || !heading || !builderDataNode) return;

    let builderData;
    try {
      builderData = JSON.parse(builderDataNode.textContent);
    } catch (_error) {
      return;
    }
    const currentBag = builderData.bags.find((bag) => bag.handle === handle) || builderData.bags[0];
    const currentPrice = currentBag
      ? new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(currentBag.price / 100)
      : (price?.textContent.match(/£[\d,.]+/)?.[0] || '');

    if (!mediaColumn.querySelector('.nn-mobile-product-summary')) {
      const summary = document.createElement('header');
      summary.className = 'nn-mobile-product-summary';
      summary.innerHTML = `
        <h1>${heading.textContent.trim()}</h1>
        <div class="nn-mobile-product-summary__meta">
          <span class="nn-mobile-product-summary__reviews" aria-label="Customer reviews will appear here when verified reviews are available">
            <span class="nn-mobile-product-summary__stars" aria-hidden="true">☆☆☆☆☆</span>
            <span>Reviews coming soon</span>
          </span>
          <strong>${currentPrice}</strong>
        </div>`;
      mediaColumn.insertBefore(summary, gallery);
    }

    if (!gallery.querySelector('.nn-product-media-counter')) {
      const counter = document.createElement('span');
      counter.className = 'nn-product-media-counter';
      counter.setAttribute('aria-live', 'polite');
      gallery.appendChild(counter);

      const slides = [...gallery.querySelectorAll('slideshow-slide')];
      const updateCounter = () => {
        const activeIndex = Math.max(0, slides.findIndex((slide) => slide.getAttribute('aria-hidden') !== 'true'));
        counter.textContent = `${activeIndex + 1} of ${slides.length}`;
        counter.setAttribute('aria-label', `Image ${activeIndex + 1} of ${slides.length}`);
      };
      updateCounter();
      if (slides.length) {
        const slideObserver = new MutationObserver(updateCounter);
        slides.forEach((slide) => slideObserver.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] }));
      }
    }

    const favourite = mediaColumn.querySelector('.nn-product-favourite');
    const summaryMeta = mediaColumn.querySelector('.nn-mobile-product-summary__meta');
    if (favourite && summaryMeta && favourite.parentElement !== summaryMeta) summaryMeta.appendChild(favourite);

    if (!mediaColumn.querySelector('.nn-mobile-product-family')) {
      const family = document.createElement('nav');
      family.className = 'nn-mobile-product-family';
      family.setAttribute('aria-label', 'Choose another Compass colour');
      family.innerHTML = '<p>Choose your Compass</p><div class="nn-mobile-product-family__track"></div>';
      const track = family.querySelector('.nn-mobile-product-family__track');
      builderData.bags.forEach((bag) => {
        const link = document.createElement('a');
        link.className = `nn-mobile-product-family__item${bag.handle === handle ? ' is-active' : ''}`;
        link.href = `/products/${bag.handle}`;
        link.setAttribute('aria-label', `${bag.handle === handle ? 'Current colour: ' : 'View '}${bag.title}`);
        if (bag.handle === handle) link.setAttribute('aria-current', 'page');
        link.innerHTML = `<span class="nn-mobile-product-family__image"><img src="${bag.image}" alt="" loading="lazy"></span><span>${bag.title}</span>`;
        track.appendChild(link);
      });
      gallery.insertAdjacentElement('afterend', family);
    }

    const offer = document.querySelector('.nn-map-builder--purchase-panel .nn-map-builder__charm-offer');
    if (offer && !offer.previousElementSibling?.classList.contains('nn-pdp-offer-note')) {
      const note = document.createElement('p');
      note.className = 'nn-pdp-offer-note';
      note.textContent = 'Choose three country charms. Your fourth is our gift.';
      offer.insertAdjacentElement('beforebegin', note);
    }

    const recommendations = document.querySelector('product-recommendations');
    (recommendations?.closest('.shopify-section') || recommendations)?.remove();

    const bottomPromiseHero = [...document.querySelectorAll('#MainContent .shopify-section.hero-wrapper')]
      .find((section) => section.textContent.includes('THE PROMISE'));
    bottomPromiseHero?.remove();

    document.querySelector('#MainContent [id*="nn_compass_lifestyle_film"]')?.remove();

    if (window.matchMedia('(max-width: 749px)').matches) {
      document.querySelector('.nn-charm-pairing')?.remove();
      const care = document.querySelector('.nn-purchase-care');
      if (care && !document.querySelector('.nn-house-promise')) {
        const promise = document.createElement('section');
        promise.className = 'nn-house-promise';
        promise.setAttribute('aria-labelledby', 'nn-house-promise-title');
        promise.innerHTML = `
          <p class="nn-house-promise__eyebrow">The North &amp; Noble Promise</p>
          <h2 id="nn-house-promise-title">Made to carry what matters.</h2>
          <p class="nn-house-promise__copy" id="nn-house-promise-copy">North &amp; Noble exists to turn the places, people and moments that shape you into something you can carry. We design in the UK with considered vegan materials, custom hand-pressed Compass hardware and a belief that meaningful pieces should be treasured, not treated as temporary. From the first journey to every one that follows, we promise thoughtful design, honest care and support that continues beyond your purchase.</p>
          <button class="nn-house-promise__toggle" type="button" aria-expanded="false" aria-controls="nn-house-promise-copy">Read more</button>`;
        care.insertAdjacentElement('afterend', promise);
        promise.querySelector('.nn-house-promise__toggle')?.addEventListener('click', (event) => {
          const expanded = event.currentTarget.getAttribute('aria-expanded') === 'true';
          event.currentTarget.setAttribute('aria-expanded', String(!expanded));
          event.currentTarget.textContent = expanded ? 'Read more' : 'Read less';
          promise.querySelector('.nn-house-promise__copy')?.classList.toggle('is-expanded', !expanded);
        });
      }

      const promise = document.querySelector('.nn-house-promise');
      const accordion = document.querySelector('.product-details .accordion');
      if (promise && accordion && !accordion.classList.contains('nn-product-information-accordions')) {
        accordion.classList.add('nn-product-information-accordions');
        const rows = [...accordion.children].filter((child) => child.querySelector?.('details'));
        const rowByHeading = new Map(rows.map((row) => [row.querySelector('summary')?.textContent.trim().toUpperCase(), row]));
        const deliveryRow = rowByHeading.get('DELIVERY & RETURNS');
        const deliveryCopy = deliveryRow?.querySelector('.details-content .text-block, .details-content');
        if (deliveryCopy) {
          deliveryCopy.innerHTML = '<p>Complimentary UK Tracked &amp; Signed Royal Mail delivery is included with every bag order. Returns are accepted within 90 days when items are unused and in their original condition.</p>';
        }
        ['SIZE & FIT', 'FEATURES & CARE', 'DELIVERY & RETURNS', 'PACKAGING'].forEach((heading) => {
          const row = rowByHeading.get(heading);
          if (row) {
            const summary = row.querySelector('summary');
            const displayHeading = {
              'SIZE & FIT': 'Size & Fit',
              'FEATURES & CARE': 'Features & Care',
              'DELIVERY & RETURNS': 'Delivery & Returns',
              PACKAGING: 'Packaging'
            }[heading];
            const headingNode = [...summary.childNodes].find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
            if (headingNode) headingNode.textContent = `\n      ${displayHeading}\n      `;
            row.querySelector('details')?.removeAttribute('open');
            accordion.appendChild(row);
          }
        });

        const reviews = document.createElement('details');
        reviews.className = 'details nn-product-information-accordions__reviews';
        reviews.innerHTML = '<summary class="details__header">Reviews</summary><div class="details-content"><p>We will only share genuine customer feedback. Verified owner reviews will appear here as soon as they are available.</p></div>';
        accordion.appendChild(reviews);
        promise.insertAdjacentElement('afterend', accordion);
        requestAnimationFrame(() => requestAnimationFrame(() => {
          accordion.querySelectorAll('details').forEach((detail) => { detail.open = false; });
        }));
      }
    }
  };

  enhanceMobileProduct();
  document.addEventListener('DOMContentLoaded', enhanceMobileProduct, { once: true });
  document.addEventListener('shopify:section:load', enhanceMobileProduct);
  const productEnhancementObserver = new MutationObserver(enhanceMobileProduct);
  productEnhancementObserver.observe(document.body, { childList: true, subtree: true });
})();
